(function(runtime) {
    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;
    var jQuery = runtime.components.dependencies.jQuery.v1_11;

    var constants = runtime.components.constants.merge({
        inputDataElem: 'data-ixp-textbox-type',
        inputSelector: '[data-ixp-textbox-type]',  // used for both <input> and <textarea>
        inputWrapSelector: '.ixp-component-textbox-input-wrap',

        css: {
            legacyPlaceholder: 'ixp-legacy-placeholder',
            textboxHidden: 'ixp-component-textbox-hidden',
            resizerHorizontal: 'ixp-component-resizer-horizontal',
            resizerVertical: 'ixp-component-resizer-vertical',
            resizerBoth: 'ixp-component-resizer-both'
        },
        extensibility: {
            events:{
                valueChanging: ':value:changing',
                valueChanged: ':value:changed'
            }
        }
    });

    runtime.components.registerExtensibility('ixp-textbox', {
        commands: constants.extensibility.commands || {},
        events: constants.extensibility.events || {}
    });

    var statics = {
        getScaffolding: function(scaffoldingKey, builder, options) {
            return {
                style: {
                    customClass: builder.getDefaultTheme('textbox')
                }
            };
        }
    };

    runtime.components.register('ixp-textbox', runtime.components.InputComponentBase, {
        initialize: function(options) {
            this._setInputType(this.inputType);
            this._setInitialValue(this.defaultValue);

            if (!this.inStudio) {
                if (this.validation_delay === undefined) {
                    this.validation_delay = 750;
                } else if (typeof this.validation_delay === 'string') {
                    this.validation_delay = parseInt(this.validation_delay, 10);
                }

                // Pretend that setting this to the max (10000) is the equivalent of off
                if (this.validation_delay == 10000) {
                    this.validation_delay = undefined;
                }

                runtime.events.on(this, this.formInstanceId + constants.inputs.events.formSubmitting, this._onFormSubmitting);
                runtime.events.on(this, this.state.instanceId + constants.inputs.events.formFieldInputRegistered, this._onFormFieldInputRegistered);
            }
        },

        onListenToInputEvents: function() {
            var onInputChanged = _.bind(this.onInputChanged, this);
            var textSelector = constants.inputSelector;
            var textChangeEvent = this.isMultiline() ? 'keyup' : 'textchange';

            if (!Modernizr.input.placeholder && this.placeholder) {
                this.$elInputWrap = this.$el.find(constants.inputWrapSelector);
                this.$elInputWrap.attr('data-ixp-placeholder', this.placeholder);
                this._onTextboxChanged(function() {}, {});

                // TODO: check placeholder behavior on older browsers for multiline
                //this.$elTextarea = this.$el.find(constants.textareaSelector);
                //this.$elTextarea.attr('data-ixp-placeholder', this.placeholder);

                this.$elInputWrap.on('click' + this.eventNamespace + ', mousedown' + this.eventNamespace + ', mouseup' + this.eventNamespace, _.bind(this._onInputWrapClicked, this));
                this.$el.on('change' + this.eventNamespace, textSelector, _.bind(_.partial(this._onTextboxChanged, onInputChanged), this));
                if (this.validation_delay) {
                    this.$el.on(textChangeEvent + this.eventNamespace, textSelector, _.bind(_.partial(this._onTextboxChanged, _.debounce(onInputChanged, this.validation_delay)), this));
                } else {
                    this.$el.on(textChangeEvent + this.eventNamespace, textSelector, _.bind(_.partial(this._onTextboxChanged, function() {}), this));
                }
            } else {
                this.$el.on('change' + this.eventNamespace, textSelector, onInputChanged);
                if (this.validation_delay) {
                    this.$el.on(textChangeEvent + this.eventNamespace, textSelector, _.debounce(onInputChanged, this.validation_delay));
                }
            }

            if (this.selectOnFocus) {
                this.$el.on('focusin' + this.eventNamespace, textSelector, _.bind(this._onInputFocused, this));
                this.$el.on('focusout' + this.eventNamespace, textSelector, _.bind(this._onInputBlurred, this));
            }

            this.$el.on(textChangeEvent + this.eventNamespace, textSelector, _.bind(this._onValueChanging, this));
        },

        _onInputWrapClicked: function(e) {
            this.setFocus();
        },

        _onFormSubmitting: function() {
            this.setValue(this.getValue(), {trigger: false, submitting: true});
        },

        _onFormFieldInputRegistered: function(e) {          
            var  textFieldLabel = jQuery(e.labelContainerSelector).get(0);
            this._setAriaLabelAttribute(textFieldLabel);
        },

        _onTextboxChanged: function(onInputChanged, e) {
            if (this.getValue() === '') {
                this.$elInputWrap.addClass(constants.css.legacyPlaceholder);
            } else if (this.$elInputWrap.hasClass(constants.css.legacyPlaceholder)) {
                this.$elInputWrap.removeClass(constants.css.legacyPlaceholder);
            }
            onInputChanged(e);
        },

        _onValueChanging: function(e) {
            var val = this.getValue(),
            ee = {
                value: val,
                hasValue: !this.isValueEmpty(val),
                required: this.state.required
            };
            this.triggerExtensibility(constants.extensibility.events.valueChanging, ee);

            if (ee.value !== this.getValue()){
                this.setValue(ee.value);
            }

            _.defer(function(me){
                val = me.getValue();
                me.triggerExtensibility(constants.extensibility.events.valueChanged, {
                    value: val,
                    hasValue: !me.isValueEmpty(val),
                    required: me.state.required
                });
            }, this);
        },

        onDestroy: function () {
            var $textElem = this.getTextElement();
            if ($textElem.length) {
                $textElem.off(this.eventNamespace);
            }
        },

        setFocus: function() {
            var $field = this.$el.closest(constants.inputs.formFieldSelector);
            if ($field.length) {
                $field.attr('tabindex', 0);
                $field.focus();
                $field.removeAttr('tabindex');
            }
            this.getTextElement().focus();
        },

        isMultiline: function() {
            return this.inputType === 'multiline';
        },

        getTextElement: function() {
            // return either the <input> or the <textarea>
            return this.$el.find(constants.inputSelector);
        },

        createTextElement: function (newInputType, $currentTextElem) {
            var elemType = (newInputType === 'multiline') ? 'textarea' : 'input';

            var $textElem = this.$('<' + elemType + ' />');
            $textElem.attr('id', 'ixp_input_' + this.instanceId);
            $textElem.attr(constants.inputDataElem, newInputType);
            if (newInputType !== 'multiline') {
                // only add type attr for <input> (textarea type='multiline' is implicit)
                $textElem.attr('type', newInputType);
            }

            $textElem.addClass('ixp-component-textbox-input');
            if (newInputType === 'multiline') {
                $textElem.addClass('ixp-component-textbox-textarea');
            }

            var dataFieldObj = JSON.parse(this.dataField);

            if (dataFieldObj && dataFieldObj.autocomplete) {
                $textElem.attr('autocomplete', dataFieldObj.autocomplete);
            }

            // either replace existing element, or create new element (first time through)
            if ($currentTextElem.length) {
                $currentTextElem.replaceWith($textElem);
                $currentTextElem.off(this.eventNamespace);
            } else {
                var $wrapper = this.$el.find(constants.inputWrapSelector);
                $textElem.appendTo($wrapper);
            }
            return $textElem;
        },

        getValue: function () {
            return this.getTextElement().val();
        },

        onSetValue: function(value) {
            this.getTextElement().val(value);
        },

        isSaveRequired: function(value) {
            // Are we optional and empty?
            if (!this.state.required && this.isValueEmpty(value)) {
                // If our value is different than the saved value and we aren't already valid, then we need to delete the saved value
                if (!this.initializing && this.dataContext.hasValue && value != this.dataContext.value) {
                    return { method: 'DELETE' };
                } else {
                    return false;
                }
            }

            return runtime.components.InputComponentBase.prototype.isSaveRequired.apply(this, arguments);
        },

        onValidateValue: function(value) {
            if (this.inputType !== 'number' ||
                (!this.required && this.isValueEmpty(value))) {
                return true;
            }

            // if it's a numeric input, check that the value is numeric and within min/max constraints
            // NOTE #1: Chrome: when input control is type='number', val() will return an empty string when there is any
            //   non-numeric text in the input (e.g. "1,000" is considered invalid due to the comma).  In this
            //   case, the input control will set its 'validity.valid' property to false.
            // NOTE #2: we investigated using the "pattern" attribute to try to allow some non-numeric text
            //   but it is not supported when type='number'
            var el = this.getTextElement()[0];
            if (el.validity && !el.validity.valid) {
                return false;
            }

            if (_.isString(value)) {
                // remove commas then try to parse as float
                value = parseFloat(value.replace(/,/g, ''));
                if (isNaN(value)) {
                    return false;
                }
            }

            if (value < (this.numberMin || 0) ||
                value > (this.numberMax || 0)) {
                return false;
            }

            return true;
        },

        _onInputFocused: function(e) {
            this.focused = true;

            _.defer(function(me) {
                if (me.focused && me.getValue()) {
                    me.$(e.target).select();
                }
            }, this);
        },

        _onInputBlurred: function(e) {
            this.focused = false;
        },

        _setInputType: function(inputType, options) {
            options || (options = {});

            this.inputType = inputType;

            var $textElem = this.getTextElement();
            var prevType = $textElem.attr('type');
            if (options.force || (prevType !== this.inputType)) {
                this.createTextElement(this.inputType, $textElem);
            }

            if (this.dataContext.validation.maxLength) {
                switch (this.inputType) {
                    case 'multiline':
                    case 'text':
                    case 'email':
                    case 'search':
                    case 'password':
                    case 'tel':
                    case 'url':
                        this.getTextElement().attr('maxlength', this.dataContext.validation.maxLength);
                }
            }

            // and now reset the other settings based on the input type
            this._setNumberLines(this.numberLines);
            this._setResize(this.resize);
            this._setPlaceholder(this.placeholder);
            this._setNumberMin(this.numberMin);
            this._setNumberMax(this.numberMax);
            this._setNumberStep(this.numberStep);

            if (this.inStudio) {
                this.setInStudioDataFieldValidation();
            }
        },

        _setInitialValue: function(defaultValue) {
            var value;
            switch (this.defaultValueType) {
                case 'none':
                    value = '';
                    break;

                case 'datafield':
                    if (!this.inStudio) {
                        if (this.dataContext.hasValue) {
                            defaultValue = this.dataContext.value;
                        } else if (this.dataContext.hasDefaultValue) {
                            defaultValue = this.dataContext.defaultValue;
                        }
                    }

                    value = defaultValue;
                    break;

                case 'custom':
                    value = defaultValue;
                    break;
            }

            this.setValue(value);
            this.validate(value);
        },

        _setNumberMin: function(val) {
            if (this.inputType === 'number') {
                var min = parseFloat(val);
                this.numberMin = isNaN(min) ? '' : min;

                if (val === '') {
                    this.getTextElement().removeAttr('min');
                } else {
                    this.getTextElement().attr('min', val);
                }

            } else {
                this.getTextElement().removeAttr('min');
            }

            if (this.inStudio) {
                this._setInitialValue(this.defaultValue);
            }
        },

        _setNumberMax: function(val) {
            if (this.inputType === 'number') {
                var max = parseFloat(val);
                this.numberMax = isNaN(max) ? '' : max;

                if (val === '') {
                    this.getTextElement().removeAttr('max');
                } else {
                    this.getTextElement().attr('max', val);
                }
            } else {
                this.getTextElement().removeAttr('max');
            }

            if (this.inStudio) {
                this._setInitialValue(this.defaultValue);
            }
        },

        _setNumberStep: function(val) {
            if (this.inputType === 'number') {
                var step = parseFloat(val);
                this.numberStep = isNaN(step) ? 0 : step;

                this.getTextElement().attr('step', this.numberStep || 'any');
            } else {
                this.getTextElement().removeAttr('step');
            }
        },

        _setPlaceholder: function(placeholder) {
            this.placeholder = placeholder;
            if (Modernizr.input.placeholder) {
                if (!placeholder) {
                    this.getTextElement().removeAttr('placeholder');
                } else {
                    this.getTextElement().attr('placeholder', placeholder);
                }
            }
        },

        _setNumberLines: function(nlines) {
            if (this.isMultiline()) {
                this.getTextElement().attr('rows', nlines);
            } else {
                this.getTextElement().removeAttr('rows');
            }
        },

        _setResize: function (resize) {
            if (this.isMultiline()) {
                this.getTextElement().css({ resize: resize });
                this.getTextElement().hide().show(0);   // NOTE: this is done so the resize handle appears immediately when the value is changed
            } else {
                this.getTextElement().css({ resize: '' });
            }
        },

        _setAriaLabelAttribute: function (textFieldLabel) {
            if(!textFieldLabel || !textFieldLabel['id']) return;
            this.getTextElement().attr('aria-labelledby', textFieldLabel.id);
        },

        studioInitialize: function(options) {
            this.deactivateEvents(this.getTextElement());
        },

        getParamMapOverrides: function() {
            return {
                inputType: this._setInputType,

                defaultValue: function(val) {
                    this.defaultValue = val;
                    this._setInitialValue(this.defaultValue);
                },

                defaultValueType: function(val) {
                    this.defaultValueType = val;
                    this._setInitialValue(this.defaultValue);
                },

                numberLines: function(val) {
                    this.numberLines = val;
                    this._setNumberLines(val);
                },

                resize: function (val) {
                    this.resize = val;
                    this._setResize(val);
                },

                placeholder: function(val) {
                    if (val !== this.placeholder) {
                        this._setPlaceholder(val);
                    }
                },

                numberMin: this._setNumberMin,

                numberMax: this._setNumberMax,

                numberStep: this._setNumberStep
            };
        },

        allowedDropTargets: function(origin) {
            if (origin === 'element'){
                return ['ixp-form-field'];
            }
            return ['ixp-form', 'ixp-form-field'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getScaffolding(scaffoldingKey, builder, options);
        }
    });
})(window.ixp.runtime);